import { combineReducers } from 'redux';
import { makeModelReducers } from '@minerva-analytics/pantheon';

import byIdPages from './byIdPages';

export default combineReducers({
  ...makeModelReducers({
    model: `category`,
    pluralModel: `categories`,
    customConfigs: {},
  }),
  byIdPages,
});
